import { Component, OnInit } from '@angular/core';
import { LtiService } from '../../services/lti.service';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-lti-frame',
    templateUrl: './lti-frame.component.html',
    styleUrls: ['./lti-frame.component.scss'],
    standalone: false
})
export class LtiFrameComponent implements OnInit {
  constructor(
    private LTIService: LtiService,
    private route: ActivatedRoute
  ) {}
  url: any;
  course;
  lms: string;
  error;
  client_id;
  ngOnInit() {
    this.route.params.subscribe(param => {
      console.log(param);

      this.route.queryParams.subscribe(query => {
        try {
          if (param.course) {
            this.course = { id: param.course };
            if (query.url) {
              this.url = decodeURIComponent(query.url);
            }
            this.lms = query.lms;
            console.log(this.course, this.url);
            this.launch();
          }
        } catch (e) {
          this.error = e;
        }
      });
    });
  }

  launch() {
    this.LTIService.linkLaunch(this.url, this.course, this.lms).subscribe(e => {
      if (e && e.oauth_signature) {
        console.log('Launch Start');
        this.submitForm(e);
      } else if (e.url) {
        document.location = e.url;
      }
    });
  }

  submitForm(data) {
    let form = this.LTIService.generateForm(this.url, 'POST', data);
    document.body.appendChild(form);
    try {
      form.submit();
    } catch (e) {
      console.log(e);
    }
    console.log('form submitted');
  }
}
